function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceiptx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75a1.5 1.5 0 00-1.5 1.5V19.5a.75.75 0 001.086.67L6 18.838l2.664 1.332a.75.75 0 00.672 0L12 18.838l2.664 1.332a.75.75 0 00.672 0L18 18.838l2.664 1.332a.75.75 0 001.086-.67V5.25a1.5 1.5 0 00-1.5-1.5zm0 14.537l-1.914-.958a.75.75 0 00-.672 0L15 18.662l-2.664-1.333a.75.75 0 00-.672 0L9 18.662l-2.664-1.333a.75.75 0 00-.672 0l-1.914.958V5.25h16.5v13.037zM9.22 12.969l1.72-1.719-1.72-1.72a.75.75 0 011.06-1.06L12 10.19l1.72-1.72a.751.751 0 011.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 11-1.06 1.06L12 12.31l-1.72 1.72a.75.75 0 11-1.06-1.06z",
    fill: props.fill
  }));
}

export default SvgReceiptx;